/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMousePointer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.9 22.7 2.3 2.2l19.2 7.7-6.7 3.3 6.9 6-1.3 1.5-7-6.1zM5.7 5.8 10 17.3l2.2-5 4.3-2.2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgMousePointer as MousePointer };
